import { render, staticRenderFns } from "./FormularioPage.vue?vue&type=template&id=5caa64f6&scoped=true"
import script from "./FormularioPage.vue?vue&type=script&lang=js"
export * from "./FormularioPage.vue?vue&type=script&lang=js"
import style0 from "./FormularioPage.vue?vue&type=style&index=0&id=5caa64f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa64f6",
  null
  
)

export default component.exports